import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';

import './index.scss';

/**
 * Revenue management details (contracts) search
 * Allows search by: region id | region name | year
 */
function RevenueManagementSearch({ create }) {
  return (
    <Box className="rev-mgmt-search__wrapper">
      <Box>Search will be here</Box>
      <Box>
        <Button color="secondary" variant="outlined" onClick={create}>
          Add
        </Button>
      </Box>
    </Box>
  );
}

RevenueManagementSearch.propTypes = {
  create: PropTypes.func.isRequired,
};

export default memo(RevenueManagementSearch);
